module.exports = __webpack_public_path__ + "identify-img-8877bbab464c7f5c8981a936162d341b.png";